export default __webpack_public_path__ + "static/media/ku.959b5d2c.svg";